import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
export default {
    async TelefonosEjecutivo(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/TelefonosEjecutivo`, datosReporte).then(response => response.data);
    },
    async DatosEjecutivo(vm, datos) {

        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/DatosEjecutivo`, datosReporte).then(response => response.data[0]);
    },
    async ObtenerIVR_Abogado(vm, prclave) {
        var formData = new FormData();
        formData.append("prclave", prclave);
        console.log(prclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/ObtenerIVR_Abogado`, formData).then(response => response.data);
    },

    async ObtenerPermisosPerfil(vm, peclave) {
        var formData = new FormData();
        formData.append("peclave", peclave);
        console.log(peclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/ObtenerPermisosPerfil`, formData).then(response => response.data);
    },

    async ObtenerDiasConcluidos(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/ObtenerDiasConcluidos`, formData).then(response => response.data);
    },
    async LlamadaIVRServ(vm, telefono, actor, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("telefono", telefono);
        datosReporte.append("actor", actor);
        datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
        return vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/IVR`, datosReporte).then(response => response.data);
    },
    async ObtenerTipoActor(vm, actor) {
        var data = new FormData();
        data.append("actor", actor);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ObtenerTipoActor`, data)
        return response.data
    },
    async ObtenerPerfil(vm) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/ObtenerPerfil`);
        return response.data
    }
}